export default [
	[
		{
			index: 'id',
			header: {
				title: 'id'
			},
			column: {}
		},
		{
			index: 'text',
			header: {
				title: 'text'
			},
			column: {
				className: 'banners-text-l'
			}
		}
	]
];


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/banners/custom-content/list/table-initial-data.js